<div class="container-fluid">
    <!-- Page Title -->
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="mb-3 d-flex align-items-center justify-content-between">
                        <div class="col-lg-3">
                            <h4 class="mb-2 fw-bolder">Repeated Order List</h4>

                        </div>
                        <div class="col-lg-3 mb-2">
                            <!-- Search Input -->
                            <input type="text" placeholder="Search by client name, ticket number, or job name" class="form-control mb-3" [(ngModel)]="searchText" (input)="onSearch()">
                        </div>
                    </div>
                    
                    <div class="table-responsive" style="max-height: 700px; overflow-y: auto;">
                        <table class="table mb-0 table-centered table-bordered">
                            <thead>
                                <tr>
                                    <th (click)="onSortColumn('orderId')">Order Id <i class="feather icon-arrow-up" *ngIf="sortColumn === 'orderId' && sortDirection === 'asc'"></i><i class="feather icon-arrow-down" *ngIf="sortColumn === 'orderId' && sortDirection === 'desc'"></i></th>
                                    <th (click)="onSortColumn('created')">Date <i class="feather icon-arrow-up" *ngIf="sortColumn === 'created' && sortDirection === 'asc'"></i><i class="feather icon-arrow-down" *ngIf="sortColumn === 'created' && sortDirection === 'desc'"></i></th>
                                    <th (click)="onSortColumn('ticketno')">Ticket No <i class="feather icon-arrow-up" *ngIf="sortColumn === 'ticketno' && sortDirection === 'asc'"></i><i class="feather icon-arrow-down" *ngIf="sortColumn === 'ticketno' && sortDirection === 'desc'"></i></th>
                                    <th (click)="onSortColumn('refno')">Ref No <i class="feather icon-arrow-up" *ngIf="sortColumn === 'refno' && sortDirection === 'asc'"></i><i class="feather icon-arrow-down" *ngIf="sortColumn === 'refno' && sortDirection === 'desc'"></i></th>
                                    <th (click)="onSortColumn('poNo')">PO No <i class="feather icon-arrow-up" *ngIf="sortColumn === 'poNo' && sortDirection === 'asc'"></i><i class="feather icon-arrow-down" *ngIf="sortColumn === 'poNo' && sortDirection === 'desc'"></i></th>

                                    <th (click)="onSortColumn('clientName')">Client Name <i class="feather icon-arrow-up" *ngIf="sortColumn === 'clientName' && sortDirection === 'asc'"></i><i class="feather icon-arrow-down" *ngIf="sortColumn === 'clientName' && sortDirection === 'desc'"></i></th>
                                    <th (click)="onSortColumn('jobName')">Job Name <i class="feather icon-arrow-up" *ngIf="sortColumn === 'jobName' && sortDirection === 'asc'"></i><i class="feather icon-arrow-down" *ngIf="sortColumn === 'jobName' && sortDirection === 'desc'"></i></th>
                                    <th (click)="onSortColumn('orderKgs')">Order Qty (Kg) <i class="feather icon-arrow-up" *ngIf="sortColumn === 'orderKgs' && sortDirection === 'asc'"></i><i class="feather icon-arrow-down" *ngIf="sortColumn === 'orderKgs' && sortDirection === 'desc'"></i></th>
                                    <th (click)="onSortColumn('avgWastage')">Avg Wastage <i class="feather icon-arrow-up" *ngIf="sortColumn === 'avgWastage' && sortDirection === 'asc'"></i><i class="feather icon-arrow-down" *ngIf="sortColumn === 'avgWastage' && sortDirection === 'desc'"></i></th>
                                    <th>status</th>
                                    <th>Preview</th>
                                    <th class="text-end">Action</th>

                                </tr>
                            </thead>
                            
                            <tbody>
                                <tr *ngFor="let item of displayedUsers">
                                    <td>{{item.orderId}}</td>
                                    <td>{{ item.created | date: 'MMM d, y' }}</td>
                                    <td>{{item.ticketno}}</td>
                                    <td>{{item.refNo}}</td>
                                    <td>{{item.poNo}}</td>
                                    <td>{{item.clientName}}</td>
                                  
                                    <td>{{item.jobName}}</td>
                               
                                    <td>{{ item.orderKgs  | number:'1.2-2':'en-US' }}</td>

                                    <td>{{item.avgWastage}}</td>
                                    <td  class="text-success">{{item.status}}</td>
                                    <td><button  (click)="previewOrder(item._id)"><i class="feather icon-printer"></i>Preview</button></td>

                                    <td class="text-end">
                                        <button  class="btn btn-outline-danger btn-sm" (click)="deleteRepeatOrder(item._id)" disabled><i class="feather icon-trash-2"></i></button>
                                        <!--<td>{{ order.orderKgs | number:'1.2-2':'en-US' }}</td>
<td>{{ order.orderPcs | number:'1.0-0':'en-US' }}</td> <button  class="btn btn-outline-primary btn-sm" (click)="edit(item._id)"><i class="feather icon-edit-2"></i></button> -->

                                    </td>
                                </tr>
                            </tbody>
                        </table><!-- end /table -->
                    </div><!-- end /table-responsive -->
                    
                    <!-- <div class="datatable-footer-inner selected-count d-flex justify-content-between">
                       
                        <div class="page-count mt-3">
                            <span class="font-weight-bold">{{ displayedUsers.length }} of {{ totalItems }} total</span>
                        </div>
                       
                        <div class="pagination mt-3 d-flex justify-content-center">
                            <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                                <i class="feather icon-chevrons-left"></i>
                            </a>
                            <a *ngFor="let page of getPages()" class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">{{ page }}</a>
                            <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === getPages().length}">
                                <i class="feather icon-chevrons-right"></i>
                            </a>
                        </div>
                    </div> -->

                    <div class="datatable-footer-inner selected-count d-flex justify-content-between">
                        <!-- Display total entries on the left side in bold -->
                        <div class="page-count mt-3">
                          <span class="font-weight-bold">{{ displayedUsers.length }} of {{ totalItems }} total</span>
                        </div>
                        
                        <!-- Pagination controls on the right side -->
                        <div class="pagination mt-3 d-flex justify-content-center">
                          <!-- Previous Page Button -->
                          <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                            <i class="feather icon-chevrons-left"></i>
                          </a>
                          
                          <!-- Page Numbers -->
                          <a *ngFor="let page of getPages()" 
                             class="pagination-circle" 
                             [class.active]="currentPage === page" 
                             (click)="onPageChange(page)">
                            {{ page }}
                          </a>
                          
                          <!-- Next Page Button -->
                          <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" 
                             [ngClass]="{'disabled': currentPage === getPages()[getPages().length - 1]}">
                            <i class="feather icon-chevrons-right"></i>
                          </a>
                        </div>
                      </div>
                      
                    <!-- end /datatable-footer-inner -->
                </div><!-- end card-body -->
            </div><!-- end card -->
        </div><!-- end col -->
    </div><!-- end row -->
</div><!-- end container -->
